<div id="cross-cutting">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card shadow-lg">
                    <h4 class="card-title text-center">Cross Cutting</h4>
                    <div class="card-body">
                        <iframe src="https://drive.google.com/file/d/1qAGp5LZiwWvOXP2sBxLMH0hJVfM-3G_r/preview" width="100%" height="980" allow="autoplay"></iframe>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>